import { table } from './_table';
import { form } from './form';

export const mailings = {
  namespaced: true,
  modules: {
    table,
    form
  }
};
